import configs from "../../configs";
import actions from "./actions";
import mutations from "./mutations";
import {Hotel} from "@/models/Hotel";
import {HotelChain} from "@/models/HotelChain";
import {POSOutlet} from "@/models/POSOutlet";
import {POSClosedDay} from "@/models/POSClosedDay";
import getters from "@/store/app/getters";
import { POSParameter } from "@/models/POSParameter";

const {product, time, theme, currencies} = configs;
const {globalTheme, menuTheme, toolbarTheme, isToolbarDetached, isContentBoxed, isRTL} = theme;
const {currency, availableCurrencies} = currencies;
const hotel: Hotel = new Hotel();
const hotels: any[] = [];
const hotelChains: HotelChain[] = [];
const outlet: POSOutlet = new POSOutlet();
const outlets: POSOutlet[] = [];
const user: any = {};
const local: any = {
  decimal_separator: ".",
  code: "ID"
};
const closed_day: POSClosedDay = new POSClosedDay();
const last_closed_day: POSClosedDay = new POSClosedDay();
const parameter: POSParameter = new POSParameter();
const state = {
  isOffline: false,
  isSyncing: false,
  isPageLoading: false,
  product,
  hotels,
  hotelChains,
  selectedHotelChainId: (() => {
    const savedChainId = localStorage.getItem("selectedHotelChainId");
    return savedChainId ? parseInt(savedChainId) : null;
  })(),
  time: "YYYY-MM-DD HH:mm:ss",
  currency,
  availableCurrencies,
  globalTheme,
  menuTheme,
  toolbarTheme,
  local,
  info: {
    type: "error",
    title: "",
    body: "",
    visible: false,
    textColor: "#E81123",
    icon: "",
    timeout: -1
  },
  isToolbarDetached,
  isContentBoxed,
  isRTL,
  hotel,
  user,
  toast: {
    show: false,
    message: "",
    timeout: 3000,
  },
  archConfirm: {
    icons: {
      "info": {
        icon: "fas fa-info-circle",
        color: "rgb(97 90 90)"
      },
      "warning": {
        icon: "fas fa-exclamation-circle",
        color: "rgb(232 186 44)"
      },
      "success": {
        icon: "mdi-check",
        color: "#366436"
      },
    },
    type: "info",
    title: null,
    message: "message",
    yes: "Yes",
    no: "No",
    show: false,
    closing: false,
    onYesCallback: null,
    onNoCallback: null,
    isTouch: false,
  },
  window: {
    width: -1,
    height: -1,
  },
  outlet,
  outlets,
  closed_day,
  last_closed_day,
  parameter,
  openToolbarMenu: null // Track which toolbar menu is currently open: 'hotels', 'outlets', 'closedDay', or null
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
